import React, {Component} from 'react';

import Marker from './Marker';
import Numbers from './Numbers';
import DragHandle from './DragHandle';
import PreloadBar from './PreloadBar';

class Slider extends Component {

    constructor(props) {
        super(props);

        this.startRef = this.ref.bind(this, 'start');
        this.stopRef = this.ref.bind(this, 'stop');

        this.state = {
            start: null,
            stop: null,
        };
    }

    render() {
        const {start, stop} = this.state;

        return (
            <div className="component-slider-wrapper">
                <div className="component-slider">
                    <DragHandle.Start marker={start} />
                    <DragHandle.Stop marker={stop} />
                    <div className="scale">
                        <Numbers />
                        <div className="slide">
                            <PreloadBar {...this.props} />
                            <Marker.Start node={start} nodeRef={this.startRef} />
                            <Marker.Stop node={stop} nodeRef={this.stopRef} />
                            <DragHandle.Now />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    ref(id, node) {
        if (node) this.setState({[id]: node});
    }

}

export default Slider;
